export const ScheduledActions = ({
  onMarkLaunched,
  onEdit,
  onCancel,
  canManage,
}) => [
  {
    label: "Mark Launched",
    icon: "ship",
    iconStyle: "solid",
    primary: true,
    onClickSingle: onMarkLaunched,
    hidden: () => !canManage,
  },
  {
    label: "Message Customer",
    icon: "messages",
    iconStyle: "solid",
    href: (row) => row.messageUrl,
  },
  {
    label: "View Contract",
    icon: "file-lines",
    iconStyle: "solid",
    href: (row) => row.reservationPath,
    hidden: (row) => !row.belongsToContract,
  },
  {
    label: "View Reservation",
    icon: "file-lines",
    iconStyle: "solid",
    href: (row) => row.reservationPath,
    hidden: (row) => row.belongsToContract,
  },
  {
    label: "Edit Details",
    icon: "pen-to-square",
    iconStyle: "solid",
    onClickSingle: onEdit,
    hidden: () => !canManage,
  },
  {
    label: "Cancel Launch",
    icon: "circle-x",
    iconStyle: "solid",
    danger: true,
    confirm: {
      title: "Cancel this launch?",
      message: (row) =>
        `Are you sure you want to cancel the launch for ${row.contactBoat.name}? This action cannot be undone.`,
      confirmLabel: "Yes, cancel",
    },
    onClickSingle: onCancel,
    hidden: () => !canManage,
  },
]

export const LaunchedActions = ({
  onMarkReturned,
  onMoveToScheduled,
  canManage,
}) => [
  {
    label: "Mark Returned",
    icon: "right-from-bracket",
    iconStyle: "solid",
    primary: true,
    onClickSingle: onMarkReturned,
    hidden: () => !canManage,
  },
  {
    label: "Message Customer",
    icon: "messages",
    iconStyle: "solid",
    href: (row) => row.messageUrl,
  },
  {
    label: "View Contract",
    icon: "file-lines",
    iconStyle: "solid",
    href: (row) => row.reservationPath,
    hidden: (row) => !row.belongsToContract,
  },
  {
    label: "View Reservation",
    icon: "file-lines",
    iconStyle: "solid",
    href: (row) => row.reservationPath,
    hidden: (row) => row.belongsToContract,
  },
  {
    label: "Move back to Scheduled",
    icon: "calendar-days",
    iconStyle: "solid",
    onClickSingle: onMoveToScheduled,
    hidden: () => !canManage,
  },
]

export const ReturnedActions = ({
  onMoveToScheduled,
  onMoveToLaunched,
  canManage,
}) => [
  {
    label: "Message Customer",
    icon: "messages",
    iconStyle: "solid",
    href: (row) => row.messageUrl,
  },
  {
    label: "View Contract",
    icon: "file-lines",
    iconStyle: "solid",
    href: (row) => row.reservationPath,
    hidden: (row) => !row.belongsToContract,
  },
  {
    label: "View Reservation",
    icon: "file-lines",
    iconStyle: "solid",
    href: (row) => row.reservationPath,
    hidden: (row) => row.belongsToContract,
  },
  {
    label: "Move back to Scheduled",
    icon: "calendar-days",
    iconStyle: "solid",
    onClickSingle: onMoveToScheduled,
    hidden: () => !canManage,
  },
  {
    label: "Move back to Launched",
    icon: "ship",
    iconStyle: "solid",
    onClickSingle: onMoveToLaunched,
    hidden: () => !canManage,
  },
]
